export const LFG_SETTINGS_STORAGE_KEY = "lfg.settings.v1";
export const LFG_SETTINGS_UPDATED_EVENT = "valovate:lfg-settings-updated";
export const LFG_SAVED_POSTS_STORAGE_KEY = "lfg.savedPosts.v2";

const DEFAULT_LFG_SETTINGS = Object.freeze({
  showHiddenMine: false,
});

export function readLfgSettings() {
  if (typeof window === "undefined") {
    return { ...DEFAULT_LFG_SETTINGS };
  }

  try {
    const rawValue = window.localStorage.getItem(LFG_SETTINGS_STORAGE_KEY);
    if (!rawValue) {
      return { ...DEFAULT_LFG_SETTINGS };
    }

    const parsedValue = JSON.parse(rawValue) || {};
    return {
      showHiddenMine: parsedValue.showHiddenMine === true,
    };
  } catch (_) {
    return { ...DEFAULT_LFG_SETTINGS };
  }
}

export function saveLfgSettings(nextSettings) {
  const normalizedSettings = {
    showHiddenMine: nextSettings?.showHiddenMine === true,
  };

  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(
        LFG_SETTINGS_STORAGE_KEY,
        JSON.stringify(normalizedSettings)
      );
    } catch (_) {
      // Local settings are best-effort only.
    }

    try {
      window.dispatchEvent(
        new CustomEvent(
          LFG_SETTINGS_UPDATED_EVENT,
          {
            detail: normalizedSettings,
          }
        )
      );
    } catch (_) {
      // Ignore event dispatch failures.
    }
  }

  return normalizedSettings;
}

export function readSavedPostIds() {
  if (typeof window === "undefined") {
    return [];
  }

  try {
    const rawValue = window.localStorage.getItem(LFG_SAVED_POSTS_STORAGE_KEY);
    const parsedValue = rawValue ? JSON.parse(rawValue) : [];
    return Array.isArray(parsedValue)
      ? parsedValue.filter((value) => typeof value === "string")
      : [];
  } catch (_) {
    return [];
  }
}
